export class DateUtils {

  static startOfDayLocal(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  static endOfDayLocal(date: Date): Date {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  }

  static toUtcIso(date: Date): string {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
        date.getMilliseconds()
      )
    ).toISOString();
  }

  // Campi date-only (es. Data prevista pianifica): il backend restituisce l'istante UTC senza
  // marcatore 'Z'. Interpreta il valore come UTC (append 'Z' se manca il timezone; se è già un
  // Date usa i suoi componenti locali) e restituisce il GIORNO locale 'YYYY-MM-DD', adatto a
  // ion-datetime/ion-input type="date". Stringa vuota se il valore non è una data valida.
  static utcToLocalDay(value: string | Date): string {
    if (!value) { return ''; }
    let d: Date;
    if (value instanceof Date) {
      d = value;
    } else {
      const hasTimezone = /[zZ]|[+-]\d{2}:\d{2}$/.test(value);
      d = new Date(hasTimezone ? value : value + 'Z');
    }
    if (isNaN(d.getTime())) { return ''; }
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  // Inverso di utcToLocalDay per il salvataggio: da un giorno locale 'YYYY-MM-DD' (o ISO troncato)
  // a un Date a mezzanotte locale. È la STESSA rappresentazione già prodotta dal write path
  // (Date → JSON UTC), quindi non altera il matching per data (feature 081).
  static localDayToDate(day: string): Date {
    return DateUtils.startOfDayLocal(new Date(day.slice(0, 10) + 'T00:00:00'));
  }
}
